var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"alerts"}},[_c('main',{staticStyle:{"text-align":"left","white-space":"normal"}},[(_vm.alerts.length)?_c('div',{staticClass:"alert"},[(_vm.alerts[_vm.index])?_c('img',{attrs:{"src":_vm.alerts[_vm.index].type.media,"alt":"Alert"}}):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49014d3f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageAlerts.vue
// module id = null
// module chunks = 